import actions from './actions';
import state from './state';

export default {
  actions,
  state,
};
